import { routeBuilder } from "./routeBuilder";

export const customFormRoutes = {

    createForm: routeBuilder('/customforms'),
    startAnswerPublic: routeBuilder('/customforms/{key}@{siteId}/answers'),
    startAnswer: routeBuilder('/customforms/{customFormId}/answers'),
    submitAnswerFields: routeBuilder('/customforms/answers/{answerId}@{siteId}'),
    submitVideoAnswerField: routeBuilder('/customforms/answers/{answerId}@{siteId}/video/{fieldId}'),
    deleteVideoAnswerField: routeBuilder('/customforms/answers/{answerId}@{siteId}/video/{fieldId}'),

    // get
    getTemplates : routeBuilder('/customforms/templates'),
    videoSubmissionEnabled: routeBuilder('/customform-settings/{siteId}/video-enabled'),


}